import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds";
import { Item } from "./Item";
/**
* **AccordionItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AccordionItem) 
*
* A list item in the accordion component.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/accordion)
*
* @example
* No example for this component
*
*/
export var AccordionItem = /*#__PURE__*/React.forwardRef(function AccordionItem(_ref, ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/React.createElement(Item, Object.assign({
    ref: ref
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.AccordionItem
  }));
});